import { compose } from 'recompose';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectors as insuranceSelectors } from 'state/direct-order/insurance';

import DiffInsured from 'components/summary/DiffInsured/styled';

const enhance = compose(
  withTranslation('Summary'),
  connect(
    (state) => ({
      insuredQuantity: Number(
        insuranceSelectors.getInsuredQuantity(state) || 0
      ),
    }),
    {}
  )
);

export default enhance(DiffInsured);
